export const hideQuickLinks = () => ({
  type: "HIDE_QUICK_LINKS"
});

export const showQuickLinks = () => ({
  type: "SHOW_QUICK_LINKS"
});
